var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"nav"}},[_c('ah-nav2',{attrs:{"brand-img":_vm.companyLogo,"active":_vm.activeMenu,"menuData":_vm.menuData,"isAllShown":_vm.isAllShown},on:{"reset":function($event){return _vm.updateReCalculateDialogVisible(true)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }